/* eslint-disable jsx-a11y/alt-text */
import React from "react";

import {
  Table,
  Button,
  Row,
  Col,
  Spin,
  Space,
  Switch,
  message,
  Form,
  Input,
  Select,
  DatePicker,
  Modal,
  Popconfirm,
  // Typography,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined,
  SearchOutlined,
  ReloadOutlined,
  ShareAltOutlined,
  // EyeOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import dayjs from "dayjs";
import { FormInstance } from "antd/lib/form";
// import locale from "antd/es/date-picker/locale/zh_CN";

import { RootState, RootDispatch } from "store";
// import CouponStockEditor from "containers/coupon/couponStockEditor";
import "../../form.css";
// const { Title } = Typography;
const { Option } = Select;
const { RangePicker } = DatePicker;

const mapState = (state: RootState) => ({
  coupons: state.coupons.coupons,
  loading: state.loading.global,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  getCouponsAsync: (data) => dispatch.coupons.getCoupons(data),
  getQRCodeAsync: (data) => dispatch.coupons.getQRCode(data),
  updateStockAsync: (data) => dispatch.coupons.updateStockAsync(data),
  toggleCouponStatusAsync: (data) =>
    dispatch.coupons.toggleCouponStatusAsync(data),
  delCouponAsync: (data) => dispatch.coupons.delCouponAsync(data),
  removeCoupon: (data) => dispatch.coupons.removeCoupon(data),
  toogleCouponStatus: (data) => dispatch.coupons.toggleCouponStatus(data),
  // updateStock: (data) => dispatch.coupons.updateStock(data),
});

type connectedProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch>;
type Props = connectedProps;

export class CouponList extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.onFormFinish = this.onFormFinish.bind(this);
    // this.onModalUpdateStockConfirm = this.onModalUpdateStockConfirm.bind(this);
    this.onPaginationChange = this.onPaginationChange.bind(this);
  }

  state = {
    isShowModalSendCoupon: false,
    QRCode: null,
    currentPage: 1,
    pageSize: 10,
  };

  refFormCouponList = React.createRef<FormInstance>();

  componentDidMount() {
    this.props.getCouponsAsync({
      page: 1,
      row: 10,
    });
  }

  // 删除确认
  deleteConfirm = (Rowdata: any, index): any => {
    this.props.delCouponAsync({ id: Rowdata.id }).then((res: any) => {
      if (res.code === "0000") {
        // this.props.removeCoupon({ index: index });
        const values = this.refFormCouponList.current.getFieldsValue();
        const { getCouponsAsync } = this.props;
        let data: any = {
          page: this.state.currentPage,
          row: this.state.pageSize,
          status: values.status === "全部" ? null : values.status,
        };
        if (Array.isArray(values.start_time)) {
          data["start_time"] = values.start_time[0].format("YYYY-MM-DD");
          data["end_time"] = values.start_time[1].format("YYYY-MM-DD");
        }
        data = Object.assign(values, data);
        getCouponsAsync(data);
        message.success("删除了" + Rowdata.name);
      } else {
        message.error("啊哟," + res.msg);
      }
    });
  };

  // 开启发放窗口
  showShareWindow = (data: any) => {
    console.log(data);
    this.props
      .getQRCodeAsync({
        page: `packageMine/pages/coupon/index?id:${data.id}`,
      })
      .then((res: any) => {
        this.setState({
          isShowModalSendCoupon: true,
          QRCode: res.data,
        });
      });
  };

  // 关闭发放窗口
  cancelShareWindow = () => {
    this.setState({
      isShowModalSendCoupon: false,
    });
  };

  // 提交表单
  onFormFinish(values) {
    const { getCouponsAsync } = this.props;
    this.setState({ currentPage: 1 });
    let data: any = {
      page: 1,
      row: this.state.pageSize,
      status: values.status === "全部" ? null : values.status,
    };
    if (Array.isArray(values.start_time)) {
      data["start_time"] = values.start_time[0].format("YYYY-MM-DD");
      data["end_time"] = values.start_time[1].format("YYYY-MM-DD");
    }
    data = Object.assign(values, data);
    getCouponsAsync(data);
  }

  // 更改优惠券状态
  toggleCouponStatus(data, index, checked) {
    // console.log(data, checked);
    const status = checked ? "1" : "0";
    console.log(status);
    this.props
      .toggleCouponStatusAsync({
        id: data.id,
        status: status,
      })
      .then((res: any) => {
        if (res.code !== "0000") {
          message.error("优惠券状态更改失败额额额");
          return;
        }
        this.props.toogleCouponStatus({ index: index, status: status });
      });
  }

  // 分页
  onPaginationChange(page, pageSize) {
    // console.log(page, pageSize);
    this.setState({
      currentPage: page,
    });
    const values = this.refFormCouponList.current.getFieldsValue();
    if (Array.isArray(values.start_time)) {
      values["start_time"] = values.start_time[0].format("YYYY-MM-DD");
      values["end_time"] = values.start_time[1].format("YYYY-MM-DD");
    }
    const data = {
      page,
      pageSize,
      ...values,
      status: values.status === "全部" ? null : values.status,
    };
    this.props.getCouponsAsync(data);
  }

  // 修改库存
  onInputStockBlur(rowData, index, e) {
    console.log(index, e.target.value, rowData);
    const { updateStockAsync } = this.props;
    const currentStock = e.target.value;
    if (currentStock === rowData.stock) return;
    // 如果库存没有改变则不需要调用接口
    if (currentStock * 1 < 0) {
      message.error("请输入不小于0的整数");
      return;
    }
    if (currentStock.split(".").length > 1) {
      message.error("请输入不小于0的整数");
      return;
    }
    if (/.*[\u4e00-\u9fa5]+.*$/.test(currentStock)) {
      message.error("请输入不小于0的整数");
      return;
    }

    // console.log(currentStock, rowData.stock);

    updateStockAsync({
      id: rowData.id,
      stock: currentStock,
      index: index,
    }).then((res: any) => {
      if (res.code === "0000") {
        // updateStock({
        //   index: index,
        //   rowData: Object.assign({}, rowData, { stock: currentStock }),
        // });
        message.success("库存更新成功咯~");
      } else {
        message.success("哎呀," + res.msg);
      }
    });
  }

  columns = [
    {
      title: "优惠券名称",
      dataIndex: "name",
      render: (text: React.ReactNode, record, index) => (
        <Link to={{ pathname: `coupon/records/${record.id}` }} target="_blank">
          {text}
        </Link>
      ),
    },
    {
      title: "面额",
      dataIndex: "quota",
      render: (text: React.ReactNode) => {
        return <div>￥{text}</div>;
      },
    },
    {
      title: "有效期",
      dataIndex: "start",
      render: (text: any, record: any) => {
        return (
          <div>
            领取{text === "0" ? null : text + "天"}后{record.end}天有效
          </div>
        );
      },
    },
    // {
    //   title: "库存",
    //   dataIndex: "stock",
    //   render: (text: any, record: any, index) => {
    //     return this.props.loading ? null : (
    //       <Form>
    //         <Form.Item
    //           name="stock"
    //           rules={[{ required: true, type: "integer" }]}
    //         >
    //           <Input
    //             style={{ width: 60 }}
    //             onBlur={this.onInputStockBlur.bind(this, record, index)}
    //             defaultValue={text}
    //           />
    //         </Form.Item>
    //       </Form>
    //     );
    //   },
    // },
    {
      title: "库存",
      dataIndex: "stock",
      render: (text: any, record: any, index) => {
        return this.props.loading ? null : (
          <Input
            style={{ width: 60 }}
            onBlur={this.onInputStockBlur.bind(this, record, index)}
            defaultValue={text}
          />
        );
      },
    },
    {
      title: "已领取",
      dataIndex: "receive",
    },
    {
      title: "已使用",
      dataIndex: "use",
    },
    {
      title: "适用品类",
      dataIndex: "category",
    },
    {
      title: "创建时间",
      dataIndex: "create_time",
      render: (text: string) => {
        return <div>{dayjs.unix(Number(text)).format("YYYY-MM-DD")}</div>;
      },
    },
    {
      title: "状态",
      dataIndex: "status",
      render: (text: any, record: any, index: any) => {
        // console.log(record);
        // const { loading } = this.props;
        return (
          <Switch
            onChange={this.toggleCouponStatus.bind(this, record, index)}
            checkedChildren="开"
            unCheckedChildren="关"
            checked={text === "1" ? true : false}
          />
        );
      },
    },
    {
      title: "操作",
      dataIndex: "id",
      render: (text: React.ReactNode, record: any, index: any) => {
        const isDisableUpdate = record.status === "1" ? true : false;
        return (
          <div>
            <Space size="middle">
              <Button
                type="primary"
                icon={<ShareAltOutlined />}
                onClick={this.showShareWindow.bind(this, record)}
              >
                发放
              </Button>
              <Link to={`/workbench/coupon/${text}`}>
                <Button icon={<EditOutlined />}>编辑</Button>
              </Link>
              <Popconfirm
                title="确定删除"
                disabled={isDisableUpdate}
                onConfirm={this.deleteConfirm.bind(this, record, index)}
              >
                <Button disabled={isDisableUpdate} icon={<DeleteOutlined />}>
                  删除
                </Button>
              </Popconfirm>
            </Space>
          </div>
        );
      },
    },
  ];

  render() {
    console.log("render");
    const dateFormat = "YYYY/MM/DD";
    const rangeStyle = {
      width: "240px",
    };
    const { coupons, loading } = this.props;
    const { list, total } = coupons;
    const { isShowModalSendCoupon, QRCode } = this.state;
    // console.log("render");
    return (
      <div>
        <div>
          {/* 搜索区域开始 */}
          <Form
            layout="inline"
            ref={this.refFormCouponList}
            onFinish={this.onFormFinish}
          >
            <Row gutter={[18, 24]}>
              <Col>
                <Link to="/workbench/coupon/add">
                  <Button type="primary" icon={<PlusOutlined />}>
                    新增
                  </Button>
                </Link>
              </Col>
              <Col>
                <Form.Item name="start_time" label="创建时间">
                  <RangePicker
                    // locale={locale}
                    format={dateFormat}
                    style={rangeStyle}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="status" initialValue={"全部"} label="状态">
                  <Select style={{ minWidth: 100 }}>
                    <Option value={null}>全部</Option>
                    <Option value="0">关</Option>
                    <Option value="1">开</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="已领取">
                  <Input.Group compact>
                    <Form.Item name="start_num">
                      <Input
                        style={{ width: 100, textAlign: "center" }}
                        placeholder="最小数量"
                      />
                    </Form.Item>
                    <Input
                      className="site-input-split"
                      style={{
                        width: 30,
                        borderLeft: 0,
                        borderRight: 0,
                        pointerEvents: "none",
                      }}
                      placeholder="~"
                      disabled
                    />
                    <Form.Item name="end_num">
                      <Input
                        className="site-input-right"
                        style={{
                          width: 100,
                          textAlign: "center",
                        }}
                        placeholder="最大数量"
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="name">
                  <Input
                    style={{ width: 250 }}
                    placeholder="请输入优惠券名称,面额等关键词"
                  />
                </Form.Item>
              </Col>
              <Col>
                <Button type="primary" htmlType="submit">
                  <SearchOutlined />
                  搜索
                </Button>
              </Col>
              <Col>
                <Button
                  type="default"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  <ReloadOutlined />
                  重置
                </Button>
              </Col>
            </Row>
          </Form>
          {/* 搜索区域结束 */}
        </div>

        <Spin tip="Loading..." size="large" spinning={loading}>
          <Table
            columns={this.columns}
            dataSource={list}
            rowKey={"id"}
            pagination={{
              total: total,
              pageSize: 10,
              current: this.state.currentPage,
              onChange: this.onPaginationChange,
              position: ["bottomCenter"],
            }}
          />
        </Spin>

        {/* 库存编辑窗口 */}
        {/* <CouponStockEditor
          editorVisible={isShowModalUpdateStock}
          editorTitle={currentRowData.name}
          onCancel={this.cancelStockWindow}
          onOk={this.onModalUpdateStockConfirm}
          ref="child"
        ></CouponStockEditor> */}

        {/* 优惠券发放窗口 */}
        <Modal
          destroyOnClose
          title="发放优惠券"
          visible={isShowModalSendCoupon}
          onOk={this.cancelShareWindow}
          onCancel={this.cancelShareWindow}
        >
          <div style={{ textAlign: "center" }}>
            <Space size="large" direction="vertical">
              <div>
                <img src={QRCode} width="240" height="240" />
              </div>
              <div>使用微信扫码打开优惠券页面</div>
            </Space>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect(mapState, mapDispatch)(CouponList);
